import {
	// We enforce not to import MUI `FormControlLabel` so all FormControlLabel
	// components will use this component. Thus we need to disable the lint rule.
	// eslint-disable-next-line no-restricted-imports
	FormControlLabel as MuiFormControlLabel,
	FormControlLabelProps,
} from '@material-ui/core';
import { css } from '@emotion/react';

const formControlLabelCss = css`
	.MuiFormControlLabel-root {
		margin-left: 0;
		margin-right: 0;
	}
	.MuiTypography-body1 {
		font-size: unset;
	}
`;

const formControlLabelSquareCss = css`
	.MuiIconButton-root {
		border-radius: 0;
		padding: 0;
	}
	.MuiFormControlLabel-root {
		margin-left: 0;
		margin-right: 0;
	}
	&.MuiFormControlLabel-root {
		margin-left: 0;
		margin-right: 0;
	}
	.PrivateSwitchBase-root-15 {
		padding: 0;
	}
	.MuiIconButton-colorPrimary:hover {
		background-color: transparent;
	}
	.MuiIconButton-colorPrimary {
		background-color: transparent;
		position: initial;
	}
	.MuiRadio-colorPrimary.Mui-checked:hover {
		background-color: transparent;
	}
	.MuiRadio-colorPrimary.Mui-checked {
		background-color: transparent;
	}
`;

/**
 * Material UI FormControlWrapper wrapper.
 *
 * @see
 * [FormControlLabel API](https://material-ui.com/api/form-control-label/)
 */
function FormControlLabel(props: FormControlLabelProps) {
	return <MuiFormControlLabel css={formControlLabelCss} {...props} />;
}

export function FormControllLabelSquare(props: FormControlLabelProps) {
	return <MuiFormControlLabel css={formControlLabelSquareCss} {...props} />;
}

export default FormControlLabel;
